import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const Fold = ({ id, title, children, big = false, hint, closed = false, badge }) => {
  const key = `fold-${id}`;
  const [open, setOpen] = useState(() => {
    const v = localStorage.getItem(key);
    return v ? v !== "closed" : !closed;
  });
  const toggle = () => { setOpen(!open); localStorage.setItem(key, open ? "closed" : "open"); };
  if (big) {
    return (
      <section data-testid={`fold-${id}`} className="mb-6 border-t border-stone-200 pt-4">
        <button data-testid={`fold-toggle-${id}`} onClick={toggle} className="group mb-4 flex w-full items-baseline gap-3 text-left">
          <ChevronDown size={18} className={`self-center text-[#9A7B2C] transition-transform ${open ? "" : "-rotate-90"}`} />
          <span className="font-display text-2xl text-[#2B2A26] group-hover:text-[#9A7B2C] transition-colors">{title}</span>
          {badge > 0 && (
            <span data-testid={`fold-badge-${id}`} className="self-center inline-flex min-w-[22px] items-center justify-center rounded-full bg-red-600 px-1.5 py-0.5 text-xs font-bold text-white tabular-nums">{badge}</span>
          )}
          {hint && <span className="text-sm text-stone-500">{hint}</span>}
          {!open && <span className="ml-auto text-xs font-bold uppercase tracking-widest text-stone-400">Show</span>}
        </button>
        {open && children}
      </section>
    );
  }
  return (
    <div data-testid={`fold-${id}`} className="mb-2">
      <button data-testid={`fold-toggle-${id}`} onClick={toggle}
        className="mb-2 inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-stone-500 hover:text-[#9A7B2C] transition-colors">
        <ChevronDown size={14} className={`transition-transform ${open ? "" : "-rotate-90"}`} /> {title} {open ? "" : "(show)"}
      </button>
      {open && children}
    </div>
  );
};
